module.exports = 'hmTouchEvents';

var angular = require('angular');
Hammer = require('hammerjs');
require('./angular.hammer')



//////////////////
// WEBPACK FOOTER
// /Users/seanopa/PhpstormProjects/courtmenow-app/~/angular-hammer/index.js
// module id = 172
// module chunks = 0